<rs-popup>
  <div class="rs-delete-owner-popup">
    <div class="rs-delete-owner-popup__title">{{ 'popups.delete-owner.are-you-sure' | translate }}</div>
    <div class="rs-delete-owner-popup__actions">
      <button
        tabindex="-1"
        mat-raised-button
        color="primary"
        class="app__button"
        [mat-dialog-close]="true">{{ 'buttons.delete' | translate | uppercase }}
      </button>
      <button
        tabindex="-1"
        mat-raised-button
        color="primary"
        class="app__button"
        mat-dialog-close>{{ 'buttons.cancel' | translate | uppercase }}</button>
    </div>
  </div>
</rs-popup>
